import { render, staticRenderFns } from "./notBuy.vue?vue&type=template&id=2dce9a65&"
import script from "./notBuy.vue?vue&type=script&lang=js&"
export * from "./notBuy.vue?vue&type=script&lang=js&"
import style0 from "./notBuy.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports